import { getDateTime } from 'app-lib/dateUtils'
import hashUtils from 'app-lib/hashUtils'
import numberUtils from 'app-lib/numberUtils'
import protocolStatsUtils from 'app-lib/protocolStatsUtils'
import chainConfigs from 'bzx-common/src/config/chains'
import { Button, ButtonClipboard, Icon } from 'bzx-common/src/ui-framework'
import { IActivityInfo } from 'bzx-common/src/domain/txTypes'
import { observer } from 'mobx-react'
import React from 'react'
import ExternalLink from 'shared-components/ExternalLink'

function EventInfo({
  info,
  devMode,
  currentUser,
}: {
  info: IActivityInfo
  devMode?: boolean
  currentUser?: boolean
}) {
  const {
    asset,
    chainId,
    leverage,
    collateral,
    type,
    value,
    txHash,
    timestamp,
    user,
    operation,
    pair,
  } = info
  const chain = chainConfigs[chainId]

  return (
    <>
      <div>
        <Icon
          className="margin-right-1 flex-no-shrink"
          name={chain.icon.name}
          color={chain.icon.color}
          size={20}
        />
        <span className="">{chain.chainDetails.shortName}</span>
      </div>

      <div className="event-info__sm">
        <Icon
          name={operation}
          size={20}
          color="var(--color-txt-muted)"
          className="margin-right-1 flex-no-shrink"
          top={-2}
        />
        <span>{operation}</span>
      </div>

      <div>
        {pair ? (
          <div>
            {type} <span className="txt-title">{pair}</span>
            <div>
              {value && <span title={value.toString()}>{numberUtils.autoFormat(value)}</span>}
              <span>{asset}</span>
              {leverage?.gt(0) && <span>{` (${numberUtils.autoFormat(leverage)}X)`}</span>}
            </div>
          </div>
        ) : collateral ? (
          <div>
            <span title={value.toFixed()}>{numberUtils.autoFormat(value)} </span>
            <span className="txt-title">{asset}</span> {type} using
            <span className="txt-title"> {collateral}</span> collateral
          </div>
        ) : (
          <div>
            {value && <span title={value.toString()}>{numberUtils.autoFormat(value)} </span>}
            <span className="txt-title">{asset}</span> {type}
          </div>
        )}
      </div>

      {!currentUser && (
        <div className="font-mono event-info__md">
          <span>User: </span>
          <span className="txt-title" title={user}>
            {hashUtils.shortHash(user)}
          </span>{' '}
          <ButtonClipboard text={user} top={-4} />
        </div>
      )}

      <div className="txt-right font-mono event-info__sm">
        <ExternalLink
          title={txHash}
          className="link--discreet"
          href={`${chain.chainDetails.blockExplorer}/tx/${txHash}`}>
          {getDateTime(timestamp)}
        </ExternalLink>
      </div>
      {devMode && (
        <div className="txt-right event-info__sm">
          <Button
            variant="blue"
            value={info}
            onClickEmit="value"
            title={`Investigate ${operation} in Impersonate mode`}
            onClick={protocolStatsUtils.openInpersonate}>
            Impersonate
          </Button>
        </div>
      )}
    </>
  )
}

export default observer(EventInfo)
